import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./index.module.css";

const formatNumber = (value) => (value == null ? "" : value.toLocaleString());

const formatPercent = (value) => (value == null ? "" : `${value}%`);

export default function ReportItemPacingDiamond({ item, isOdd }) {
  return (
    <div
      className={classNames(
        styles.iboItem,
        isOdd && styles.odd,
        item.isTotalRow && styles.totalRow
      )}
    >
      <div className={styles.asOf}>{item.asOf}</div>
      <div className={styles.diamond}>
        {item.isTotalRow ? "Total" : item.diamond}
      </div>
      <div className={styles.currentComp}>{formatNumber(item.currentComp)}</div>
      <div className={styles.currentPaid}>{formatNumber(item.currentPaid)}</div>
      <div className={styles.currentTotal}>
        {formatNumber(item.currentTotal)}
      </div>
      <div className={styles.priorComp}>{formatNumber(item.priorComp)}</div>
      <div className={styles.priorPaid}>{formatNumber(item.priorPaid)}</div>
      <div className={styles.priorTotal}>{formatNumber(item.priorTotal)}</div>
      <div className={styles.percentOfChange}>
        {formatPercent(item.percentOfChange)}
      </div>
    </div>
  );
}

ReportItemPacingDiamond.propTypes = {
  item: PropTypes.shape({
    diamond: PropTypes.string,
    asOf: PropTypes.string,
    currentComp: PropTypes.number,
    currentPaid: PropTypes.number,
    currentTotal: PropTypes.number,
    priorComp: PropTypes.number,
    priorPaid: PropTypes.number,
    priorTotal: PropTypes.number,
    percentOfChange: PropTypes.number,
    isTotalRow: PropTypes.number,
  }),
  isOdd: PropTypes.bool,
};